<!--
 * @Description: xuzhongqi
 * @Version: 1.0
 * @Autor: xuzhongqi
 * @Date: 2022-01-10
 * @LastEditors: Jeson
 * @LastEditTime: 2022-03-02 15:49:07
-->
<template>
  <div>

    <el-row
      class="item-box"
    >
      <el-col :span="24">
        <el-row
          :gutter="20"
        >
          <el-col :span="5">
            <div class="item-row-logo" @click="handleSeeDetial(item)">
              <van-image
                :src="item.CommodityList[0].Logo"
                fit="cover"
                class="reduction"
              >
                <template #error>加载失败</template>
              </van-image>
              <!-- 图片下方固定规则 -->
              <div
                v-if="item.CommodityList[0].ActivityInfo && item.CommodityList[0].ActivityInfo.ActivityDescribe && (TypeText === '满赠' || TypeText === '换购')"
                class="item-rule-fixed"
                :class="{'item-rule-fixed-bg2': TypeText === '满赠','item-rule-fixed-bg3': TypeText === '换购' }"
              >{{ item.CommodityList[0].ActivityInfo.ActivityDescribe }}</div>
            </div>
          </el-col>
          <el-col :span="19">
            <el-col :span="24">
              <el-row>
                <div @click="handleSeeDetial(item)">
                  <el-col :span="9" class="border">
                    <el-col :span="24">
                      <div class="item-row">
                        <label class="item-row-label">
                          <img
                            v-if="item.isNewProduct"
                            src="../../../assets/new.png"
                            fit="cover"
                            class="reduction"
                          >
                          {{ item.CommodityList[0].SkuName }}
                        </label>
                      </div>
                    </el-col>
                    <el-col :span="24">
                      <div class="item-row">
                        <span class="item-row-introduce">规格：{{ item.CommodityList[0].Specifications }}/{{ item.CommodityList[0].Unit }}</span>
                      </div>
                    </el-col>
                    <el-col :span="24">
                      <div class="item-row">
                        <span class="item-row-introduce">效期：{{ item.CommodityList[0].Validity }}</span>
                      </div>
                    </el-col>
                    <el-col :span="24">
                      <div class="item-row">
                        <nav class="item-price-detailed">
                          <span class="item-price-catching">最低零售¥{{ item.CommodityList[0].RetailPrice.toFixed(2) }}</span>
                          <span
                            v-if="item.CommodityList[0].RetailPrice === 0"
                            class="item-price-low"
                          >
                            毛利率
                            {{ _showProductProfit(
                              item.CommodityList[0].RetailPrice,
                              _getProductPrice(
                                item.CommodityList[0].ActivityPrice,
                                item.CommodityList[0].PriceLimit
                              )
                            ) }}%</span>
                          <span
                            v-else
                            class="item-price-low"
                          >毛利率0</span>
                        </nav>
                      </div>
                    </el-col>
                    <el-col :span="24">
                      <div class="item-row">
                        <nav class="item-price-mark">
                          <span
                            v-if="TypeText !== ''"
                            class="item-price-mark-style1"
                          >{{ TypeText }}</span>
                          <span
                            v-if="item.CommodityList[0].MedicalType === 0"
                            class="item-price-mark-style2"
                          >医保</span>
                          <span
                            v-else-if="item.CommodityList[0].MedicalType === 1"
                            class="item-price-mark-style2"
                          >甲类</span>
                          <span
                            v-else-if="item.CommodityList[0].MedicalType === 2"
                            class="item-price-mark-style2"
                          >乙类</span>
                          <span
                            v-else-if="item.CommodityList[0].MedicalType === 3"
                            class="item-price-mark-style2"
                          >医保</span>
                          <span
                            v-if="item.CommodityList[0].CountryCode !== ''"
                            class="item-price-mark-style3"
                          >国家码</span>
                        </nav>
                      </div>
                    </el-col>
                    <el-col :span="24">
                      <div class="item-row">
                        <div class="flex-count-row">
                          <van-count-down
                            class="search-count-view"
                            :time="item.TimeStamp"
                          >
                            <template #default="timesData">
                              <span>距活动结束剩余 {{ timesData.days }}天</span>
                              <span class="search-count-timer">{{ prefixInteger(timesData.hours,2) }}</span>
                              <span>:</span>
                              <span class="search-count-timer">{{ prefixInteger(timesData.minutes,2) }}</span>
                              <span>:</span>
                              <span class="search-count-timer">{{ prefixInteger(timesData.seconds,2) }}</span>
                            </template>
                          </van-count-down>
                        </div>
                      </div>
                    </el-col>
                  </el-col>
                  <el-col :span="5" class="border" @click="handleSeeDetial(item)">
                    <div class="flex-justify-row">
                      <div>
                        <span class="flex-justify-row-catching">¥ {{ item.CommodityList[0].PriceLimit.toFixed(2) }}</span>
                        <span
                          v-if="TypeText === '特价' || TypeText === '秒杀' || TypeText === '效期'"
                          class="flex-justify-row-commonly"
                        >原价 : {{ item.CommodityList[0].Price.toFixed(2) }}</span>
                      </div>
                    </div>
                  </el-col>
                </div>

                <el-col :span="5" class="border">
                  <div class="flex-justify-row">
                    <van-stepper
                      v-model="item.CommodityList[0].Count"
                      :min="item.CommodityList[0].StartNumber"
                      :max="item.CommodityList[0].SingleOrderLimitNumb"
                      :step="item.CommodityList[0].StepLengthNumber"
                      :disable-plus="item.CommodityList[0].Count >= item.CommodityList[0].Stock ||(item.CommodityList[0].SingleOrderLimitNumb && item.CommodityList[0].Count >= item.CommodityList[0].SingleOrderLimitNumb) || (item.CommodityList[0].SingleOrderLimitNumb && item.CommodityList[0].Count >= item.CommodityList[0].SingleOrderLimitNumb) "
                      integer
                    />
                  </div>
                </el-col>
                <el-col :span="5">
                  <div class="flex-justify-row">
                    <div
                      class="btn"
                      @click="addShoppingCart(item)"
                    >加入购物车</div>
                  </div>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="24">
              <el-row>
                <el-col :span="20">
                  <div class="item-row">
                    <div class="flex-rule-row">{{ item.RuleTransformationList[0] }}</div>
                  </div>
                </el-col>
                <el-col :span="4">
                  <div class="item-row">
                    <div class="flex-rule-row">
                      <div
                        slot="reference"
                        class="flex-justify-more"
                      >
                        <el-popover
                          placement="bottom"
                          title="所有规则"
                          width="300"
                          trigger="click"
                          :content="item.RuleTransformationList.join('，')"
                        >
                          <img
                            slot="reference"
                            src="../../../assets/down.png"
                            fit="cover"
                            class="search-icon"
                          >
                        </el-popover>
                      </div>
                    </div>
                  </div>
                </el-col>
              </el-row>
            </el-col>
          </el-col>
        </el-row>
      </el-col>
    </el-row>

  </div>
</template>

<script>
import { BaseMixin } from '@/mixins/BaseMixin'
export default {
  components: {},
  mixins: [BaseMixin],
  props: {
    // 监听父组件传递的展示值
    defaultData: {
      type: Object,
      default: () => {}
    },
    // 监听父组件传递的活动大类
    ActivityType: {
      type: Number,
      default: () => 0
    }
  },
  data() {
    return {
      // 模糊查询关键字
      Keyword: '',
      // 组件展示默认值对象
      item: {},
      // 活动大类
      TypeText: ''
    }
  },
  computed: {},
  watch: {
    defaultData: {
      handler(newVal) {
        // 覆盖本地行数据对象
        this.item = newVal
      },
      deep: true, // true 深度监听
      immediate: true // 第一次绑定是否执行
    },
    ActivityType: {
      handler(newVal) {
        // 转换活动类型枚举值
        switch (newVal) {
          case 1:
            this.TypeText = '商城'
            break
          case 2:
            this.TypeText = '专区'
            break
          case 3:
            this.TypeText = '满赠'
            break
          case 4:
            this.TypeText = '换购'
            break
          case 5:
            this.TypeText = '特价'
            break
          case 6:
            this.TypeText = '满减'
            break
          case 7:
            this.TypeText = '满返'
            break
          case 8:
            this.TypeText = '秒杀'
            break
          case 9:
            this.TypeText = '效期'
            break
          default:
            this.TypeText = ''
        }
      },
      deep: true, // true 深度监听
      immediate: true // 第一次绑定是否执行
    }
  },
  created() {},
  methods: {
    /*
     * 数字补0方法
     * @param num {number} 需要转换的数值
     * @param size {number} 需要转换的数值长度
     * @return 补0后的数值
     */
    prefixInteger(num, size) {
      return (Array(size).join(0) + num).slice(-size)
    },
    /*
     * 查看详情
     * @param item {object} 跳转行对象
     */
    handleSeeDetial(item) {
      console.log(item)
      this._jump(this.Enum_LinkTypeCode.ProductDetails, item.CommodityList[0]['Id'], '_blank')
    },
    /*
     * 加入购物车
     * @param item {object} 跳转行对象
     */
    async addShoppingCart(item) {
      // 组装提交数据
      const formData = {
        ProductSKUId: item.CommodityList[0].Id, // 商品ID
        ActivityId: item.Id, // 活动ID
        Count: item.CommodityList[0].Count, // 数量
        IsAdd: true // 是否累加商品
      }
      // 调用接口
      const res = await this.postAction(
        '/api_order/ShoppingCarts/AddOrUpdateCart',
        formData
      )
      if (!res.IsSuccess) {
        this.$toast({ position: 'bottom', message: res.Msg })
        return
      }
      // 判断是否可以加购
      if (
        res.Data.IsLimitPerOrder &&
        !!item.CommodityList[0].SingleOrderLimitNumb
      ) {
        const comparison = this.$hys.checkLimitPerOrder(
          item.CommodityList[0].StartNumber,
          item.CommodityList[0].StepLengthNumber,
          item.CommodityList[0].SingleOrderLimitNumb
        )
        if (comparison > item.CommodityList[0].StepLengthNumber) {
          item.CommodityList[0].Count = comparison
        } else {
          item.CommodityList[0].Count = item.CommodityList[0].StartNumber
        }
        this.$toast({
          position: 'bottom',
          message:
            '单笔订单限购（' +
            item.CommodityList[0].SingleOrderLimitNumb +
            '）' +
            item.CommodityList[0].Unit
        })
        return
      }
      // 添加成功
      this.$toast({
        position: 'center',
        message: '添加购物车成功'
      })
      // 添加成功，刷新顶部栏，侧边栏，悬浮购物车数量
      this.$bus.$emit('buycarChanged', res.Data.CountData.ProductCount, true)
      this.$bus.$emit(
        'rightBuycarChanged',
        res.Data.CountData.ProductCount,
        true
      )
    }
  }
}
</script>

<style lang="less" scoped>
@import url("~@/styles/activityView.less");
</style>
